import { render, staticRenderFns } from "./TestComponent.vue?vue&type=template&id=10d3bbe6&scoped=true&"
import script from "./TestComponent.vue?vue&type=script&lang=ts&"
export * from "./TestComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d3bbe6",
  null
  
)

export default component.exports